import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './pagination.scss';
import { GeckoBtns, GeckoFields, GeckoToastService } from '../../';
import { GeckoPaginationModel } from '../../models';

class GeckoPagination extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: this.props.pagination ? this.props.pagination.current_page : 1,
    };
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (
      this.props.pagination.current_page !== nextProps.pagination.current_page
    )
      this.setState({ pageNo: nextProps.pagination.current_page });
  }

  renderTotal() {
    return <span>Found {this.props.pagination.total_items || 0} results.</span>;
  }

  changePageHandler(key, value) {
    this.setState({ [key]: value });
  }

  changePageSubmit() {
    if (
      this.state.pageNo > this.props.pagination.total_pages ||
      this.state.pageNo < 0
    )
      return new GeckoToastService().error('Page does not exist');
    return this.props.pagination.changePage(this.state.pageNo);
  }

  renderPageSearch() {
    const fields = [{ key: 'pageNo', type: 'text', label: null }];
    const values = { pageNo: this.state.pageNo };

    if (this.props.pagination.total_pages > 1) {
      return (
        <span>
          Showing page
          <GeckoFields
            fields={fields}
            values={values}
            submitHandler={this.changePageSubmit.bind(this)}
            handler={this.changePageHandler.bind(this)}
          />
          of {this.props.pagination.total_pages}.
        </span>
      );
    }
    return null;
  }

  btns = [
    {
      icon: 'far fa-angle-left',
      handler: () => {
        this.props.pagination.changePage(
          this.props.pagination.current_page - 1
        );
        this.changePageHandler(
          'pageNo',
          this.props.pagination.current_page - 1
        );
      },
      disabledWhen: () => this.props.pagination.current_page === 1,
    },
    {
      icon: 'far fa-angle-right',
      handler: () => {
        this.props.pagination.changePage(
          this.props.pagination.current_page + 1
        );
        this.changePageHandler(
          'pageNo',
          this.props.pagination.current_page + 1
        );
      },
      disabledWhen: () =>
        this.props.pagination.current_page ===
        this.props.pagination.total_pages,
    },
  ];

  renderBtns() {
    if (this.props.pagination.total_pages > 1) {
      return <GeckoBtns items={this.btns} group />;
    }
    return null;
  }

  render() {
    if (!this.props.pagination) return null;
    return (
      <div className="gecko-pagination">
        <span className="results-text">
          {this.renderTotal()}
          &nbsp;
          {this.renderPageSearch()}
        </span>

        {this.renderBtns()}
      </div>
    );
  }
}

GeckoPagination.propTypes = {
  pagination: PropTypes.shape(GeckoPaginationModel),
};

export default GeckoPagination;
